import { attributes, define, Events, refTo } from '@type-r/models';
import { Linked, useIO, useModel } from '@type-r/react';
import { PopupIODialog } from 'lqx-react';
import * as React from 'react';
import { CompanyModel, globalStore, PlatformCompany, RelationshipModel } from 'api';
import { Payment } from 'src/app/pages/inmatch/api';
import { UnresolvedPayment } from '../../api/unresolvedPayment';
import { PaymentDetails } from '../../bank-transactions/unresolved/details';
import { Loading } from 'lqx-react/src';

@define 
class State extends attributes({
    companies : [ PlatformCompany ],
    customer : refTo( PlatformCompany ),
    supplier : refTo( PlatformCompany ),
}){
    async fetch(){   
        this.companies = globalStore.platformCompanies;

        return this;
    }    
}

export const UpdateConversationDialog = ({ $isOpen, payment} : {
    $isOpen : Linked<boolean>,
    payment : Payment,
}) => {
    const state = useModel( State );
    
    const isReady = useIO(
        () => state.fetch(),
        [ state ]
    );

    const asUnresolvedPayment : UnresolvedPayment = new UnresolvedPayment({
        id: payment.id,
        typeId: payment.typeId,
        currency: payment.currency,
        amout: payment.amount,
        statementDate: payment.statementDate,
        valueDate: payment.valueDate,
        customer: {
            name: payment.customerName,
            account: payment.paymentDetail.creditorAccount,
            bankName: payment.paymentDetail.creditorBankName
        },
        supplier: {
            id: payment.payorAgentPlatformCompanyId ? payment.supplierPlatformCompanyId : null,
            name: payment.supplierName,
            account: payment.paymentDetail.debtorAccount,
            bankName: payment.paymentDetail.debtorBankName
        },
        remittanceInfoUnstructured: payment.paymentDetail.remittanceInfoUnstructured,
        additionalEntryInfo: payment.paymentDetail.additionalEntryInfo,
        payorAgentId: payment.payorAgentPlatformCompanyId,
    });

    return (
        <PopupIODialog
            $isOpen={ $isOpen }
            title="Update relationship"
            actionLabel="Confirm"
            maxWidth="lg"
            success='Relationship is updated'
            disabled={ !state.customer || !state.supplier }
            doIO={ async () => {

                await asUnresolvedPayment.resolveAll(state.customer.id, state.supplier.id, payment.id);
            }}
            onSuccess={
                () => Events.trigger( "selectedPayment:refresh" )
            }
        >
            <>

            { isReady ?
                <PaymentDetails 
                    payment={asUnresolvedPayment} 
                    companies={state.companies} 
                    showResolveDialog={false}
                    $supplier={state.$.supplier}
                    $customer={state.$.customer} /> : <Loading /> }
            
            </>
        </PopupIODialog> )
}
